import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const util = require('../utils/index');
const process = require('../env');

const getCredentials = () => {
  const userLogged = util.getUser();

  const credentials = {
    username: userLogged.login,
    password: userLogged.senha
  }

  return credentials;
}


export const registrarResponsavelApi = async (formValue) => {
  try{
  
      const response = await axios.post(`${process.env.URL}/responsible/createResponsible`, formValue, {
        auth: getCredentials()
      })
  
      if (response.status === 200){
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const listarTodosResponsaveisApi = async (body) => {
  try{
      const response = await axios.post(`${process.env.URL}/responsible/getallresponsible`, body,  {
        auth: getCredentials()
      })
      
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const listarResponsavelApi = async (body) => {
  try{
      const response = await axios.post(`${process.env.URL}/responsible/getResponsible`, body, {
        auth: getCredentials()
      })
      
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarResponsavelApi = async (id) => {
  try{ 

      const response = await axios.post(`${process.env.URL}/responsible/getResponsibleByID`, id, {
        auth: getCredentials()
      })

      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarFilialPorResponsavel = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/severalResponsible/getBranchByResponsible`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const atualizarResponsavelApi = async (formValue) => {
  try{
      const response = await axios.put(`${process.env.URL}/responsible/updateResponsible`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const excluirResponsavelApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/responsible/deleteResponsible`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);

    }
  return false;
}